<template>
  <div class="medical-records-tab medical-records-tab--therapeutic-plan">
    <p class="text-muted mb-0">{{ $t("prontuariosPage.tabs.therapeuticPlan.placeholder") }}</p>
  </div>
</template>

<script>
export default {
  name: "MedicalRecordsTherapeuticPlanTab",
  props: {
    entityType: {
      type: String,
      default: "",
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    patient: {
      type: Object,
      default: null,
    },
  },
};
</script>
